<div class="flex items-center gap-1 select-none justify-center w-full">
    @if (canGoPrev()) {
        @if (page() !== 1) {
            <div class="page-button">
                <app-icon
                    name="ri:skip-left-line"
                    (click)="setPage(1)"
                    class="theme-text"
                />
            </div>
            <div class="page-button" (click)="setPage(page() - 1)">
                <app-icon name="mdi:chevron-left" class="theme-text" />
            </div>
        }
    }
    @for (_page of pages(); track _page) {
        <div
            [attr.data-page]="_page"
            [attr.data-active]="page() == _page"
            (click)="setPage(_page)"
            class="page-button"
        >
            {{ _page }}
        </div>
    }
    @if (canGoNext()) {
        @if (page() !== pageInfo()?.totalPages) {
            <div class="page-button" (click)="setPage(page() + 1)">
                <app-icon name="mdi:chevron-right" class="theme-text" />
            </div>
            <div class="page-button">
                <app-icon
                    name="ri:skip-right-line"
                    (click)="setPage(pageInfo().totalPages || 0)"
                    class="theme-text"
                />
            </div>
        }
    }
</div>
